const Overlay = {
  enter: "ease-out duration-300",
  enterFrom: "opacity-0",
  enterTo: "opacity-100",
  leave: "ease-in duration-200",
  leaveFrom: "opacity-100",
  leaveTo: "opacity-0",
}

const Main = {
  enter: "transition-all duration-500",
  enterFrom: "transform -translate-x-full lg:-ml-64",
  enterTo: "transform translate-x-0 lg:ml-0",
  leave: "transition-all duration-300",
  leaveTo: "transform -translate-x-full lg:-ml-64",
}

const Children = {
  enter: "transform delay-200 ease-out duration-300",
  enterFrom: "opacity-0 translate-y-8",
  enterTo: "opacity-100 translate-y-0",
  leave: "transform ease-in duration-200",
  leaveFrom: "opacity-100 translate-y-0",
  leaveTo: "opacity-0 translate-y-8",
}

export default { Overlay, Main, Children }